import { render, staticRenderFns } from "./AgentYtdRevenueContributionNumberDisplayer.vue?vue&type=template&id=5f2d8090"
import script from "./AgentYtdRevenueContributionNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./AgentYtdRevenueContributionNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports